// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/security/guards/auth.guard';
import { BaseComponent } from '@theme/base/base.component';
import { ErrorPageComponent } from '@theme/error-page/error-page.component';
import { ControlModule } from 'app/modules/gestion/control.module';
import { environment } from 'environments/environment';

// Components

const routes: Routes = [
	{
		path: environment.PATH_BASE,
		component: BaseComponent,
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		children: [
			{
				path: 'gestion',
				loadChildren: (): Promise<typeof ControlModule> =>
					import('app/modules/gestion/control.module').then((m) => m.ControlModule),
			},

			{
				path: '',
				redirectTo: `/${environment.PATH_BASE}/gestion/autoliquidacion`,
				pathMatch: 'full',
			},
			{ path: '**', redirectTo: '../error/403', pathMatch: 'full' },
		],
	},
	{
		path: 'error/403',
		component: ErrorPageComponent,
		data: {
			type: 'error-v6',
			code: 403,
			title: 'Prohibido pasar',
			desc: 'Tranquilo ratón, aún no desarrollamos esto.<br> Please, contact Almircar.',
		},
	},
	{
		path: 'error/acceso-denegado',
		component: ErrorPageComponent,
		data: {
			type: 'error-v6',
			code: 403,
			title: 'Prohibido pasar',
			desc: 'No tiene permisos para ver esta página',
		},
	},
	{ path: '**', redirectTo: environment.PATH_BASE, pathMatch: 'full' },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: 'disabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
